<template>
    <table class="table table-hover no-overflow">
        <thead>
            <tr>
                <th @click="sortBy('referenceNumber')">
                    Folio de consulta BC
                    <span v-if="sortKey === 'referenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('loanApplication.referenceNumber')">
                    Folio de Solicitud
                    <span v-if="sortKey === 'loanApplication.referenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('loanApplication.prospectus.referenceNumber')">
                    Folio de Prospecto
                    <span v-if="sortKey === 'loanApplication.prospectus.referenceNumber'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('placeIssuance')">
                    Lugar
                    <span v-if="sortKey === 'placeIssuance'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('dateIssuance')">
                    Fecha
                    <span v-if="sortKey === 'dateIssuance'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('officerFullName')">
                    Nombre del funcionario que recaba la autorización
                    <span v-if="sortKey === 'officerFullName'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('inquiryDate')">
                    Fecha de consulta de BC
                    <span v-if="sortKey === 'inquiryDate'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('loanApplication.prospectus.generalInformation.firstName')">
                    Nombre del solicitante
                    <span v-if="sortKey === 'loanApplication.prospectus.generalInformation.firstName'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('loanApplication.prospectus.personType.name')">
                    Tipo de persona
                    <span v-if="sortKey === 'loanApplication.prospectus.personType.name'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="sortBy('status.name')">
                    Estatus
                    <span v-if="sortKey === 'status.name'">
                        <i :class="sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th>Acciones</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="item in sortedData" :key="item.id" v-if="sortedData.length != 0">
                <td class="sorting_1 dtr-control">{{ item.referenceNumber }}</td>
                <td>{{ item.loanApplication.referenceNumber }}</td>
                <td>{{ item.loanApplication.prospectus.referenceNumber }}</td>
                <td>{{ item.placeIssuance }}</td>
                <td>{{ $filters.formatDate(item.dateIssuance) }}</td>
                <td>{{ item.officerFullName }}</td>
                <td>{{ $filters.formatDate(item.inquiryDate) }}</td>
                <td>{{ getName(item) }}</td>
                <td>{{ item.loanApplication.prospectus.personType.name }}</td>
                <td>{{ item.status.name }}</td>
                <td>
                    <PrimaryButton class="btn-success" data-toggle="modal" data-target="#modal-xl"
                        @click.prevent="editItem(item)">
                        <i class="fa fa-edit"></i>
                    </PrimaryButton>
                </td>
            </tr>
            <tr v-else>
                <td colspan="11" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
import PrimaryButton from '@/Components/PrimaryButton.vue';

export default {
    components: { PrimaryButton },
    data() {
        return {
            sortKey: '',
            sortOrder: 1, // 1 for ascending, -1 for descending
        };
    },
    emits: ['edit-item'],
    props: {
        list: {
            type: Array,
            default: () => [],
            required: true,
        },
        itemsPerPage: {
            type: Number,
            default: () => 10,
        },
        currentPage: {
            type: Number,
            default: () => 1
        }
    },
    computed: {
        sortedData() {
            let sortedList = [...this.list];
            if (this.sortKey) {
                sortedList.sort((a, b) => {
                    let aValue = this.getNestedValue(a, this.sortKey);
                    let bValue = this.getNestedValue(b, this.sortKey);

                    if (aValue < bValue) return -1 * this.sortOrder;
                    if (aValue > bValue) return 1 * this.sortOrder;
                    return 0;
                });
            }
            return this.paginate(sortedList);
        }
    },
    methods: {
        sortBy(key) {
            if (this.sortKey === key) {
                this.sortOrder *= -1; // Toggle the sort order
            } else {
                this.sortOrder = 1; // Reset to ascending if a new column is sorted
            }
            this.sortKey = key;
        },
        getNestedValue(obj, key) {
            return key.split('.').reduce((o, i) => o[i], obj);
        },
        paginate(list) {
            if (!list || list.length === 0) return [];
            let start = (this.currentPage * this.itemsPerPage) - this.itemsPerPage;
            return list.slice(start, start + this.itemsPerPage);
        },
        getName(item) {
            if (item.loanApplication.prospectus.generalInformation.businessName != null) {
                return item.loanApplication.prospectus.generalInformation.businessName;
            } else {
                return `${item.loanApplication.prospectus.generalInformation.firstName} ${item.loanApplication.prospectus.generalInformation.lastName} ${item.loanApplication.prospectus.generalInformation.mothersMaidenName}`;
            }
        },
        editItem(item) {
            this.$emit('edit-item', item);
        }
    }
}
</script>